module.exports = __webpack_public_path__ + "static/media/2.e7dbcf6c.svg";